let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cMyEp")).then(() => parcelRequire('buRQq'));